<!-- Start- Ejemplo Sidenav -->

<!-- Página no encontrada Start -->
<div class="not-found">
    <mat-card>
        <mat-card-content class="text-center">
            <img src="./assets/images/logo.svg" alt="logo" class="w-100 not-found-logo">
            <mat-card-title>{{'lbl_algo_salio_mal' | translate : listTraduction.lbl }}</mat-card-title>
            <p>{{'lbl_puede_que_la_pagina_que_buscas_no_exista' | translate : listTraduction.lbl }}</p>
            <button mat-button mat-stroked-button color="primary" class="w-100" (click)="returnHome()" type="button">{{'lbl_ir_al_inicio' | translate : listTraduction.lbl }}</button>
        </mat-card-content>
    </mat-card>
</div>

<!-- //End - Página no encontrada -->

<!--
<div class="page-body not-found">
    <mat-card>
      <mat-card-content class="text-center">
        <img src="./assets/images/logo.svg" alt="logo" class="w-100 not-found-logo">

        <mat-card-title *ngIf="!errorType">
          {{'lbl_algo_salio_mal' | translate : listTraduction.lbl }}
        </mat-card-title>
        <mat-card-title *ngIf="errorType" class="error-title">
          {{ getErrorMessage() }}
        </mat-card-title>

        <p *ngIf="!errorType">
          {{'lbl_puede_que_la_pagina_que_buscas_no_exista' | translate : listTraduction.lbl }}
        </p>

        <div *ngIf="errorType === 'resourceUnavailable'" class="error-message">
          <p>No se pudo acceder a un recurso necesario para mostrar esta pantalla. Esto puede deberse a problemas de red o a que el servicio está temporalmente no disponible.</p>
        </div>

        <div *ngIf="errorType === 'timeout'" class="error-message">
          <p>La operación ha excedido el tiempo máximo de espera. Esto puede deberse a problemas de red o a que el servidor está experimentando una alta carga de trabajo.</p>
        </div>

        <div *ngIf="errorType === 'actionError'" class="error-message">
          <p>No se pudo completar la acción solicitada. Por favor, verifique que la información ingresada sea correcta e intente nuevamente.</p>
        </div>

        <div *ngIf="shouldShowDetails()" class="error-details mt-4 mb-4">
          <mat-divider class="mb-3"></mat-divider>
          <h3 class="text-left mb-3">Detalles del error:</h3>

          <div class="error-details-container text-left">
            <div *ngFor="let detail of getFormattedDetails()" class="mb-2">
              <strong>{{ detail.label }}</strong> {{ detail.value }}
            </div>
          </div>

          <mat-divider class="mt-3"></mat-divider>
        </div>

        <div class="mt-4 mb-4 text-left instructions-container">
          <h3>Recomendaciones:</h3>
          <ul>
            <li>Intente recargar la página</li>
            <li>Verifique su conexión a internet</li>
            <li>Si el problema persiste, contacte al administrador del sistema</li>
          </ul>
        </div>

        <div *ngIf="errorDetails" class="error-code mt-2 mb-4">
          <small>Código de referencia: {{ errorDetails.timestamp | date:'yyyyMMddHHmmss' }}</small>
        </div>

        <div class="d-flex justify-content-center mt-4">
          <button mat-stroked-button color="primary" class="mx-2" (click)="goBack()">
            <i class="fa-solid fa-arrow-left me-2"></i>
            Volver
          </button>

          <button mat-flat-button color="primary" class="mx-2" routerLink="/modules">
            <i class="fa-solid fa-home me-2"></i>
            {{'lbl_ir_al_inicio' | translate : listTraduction.lbl }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  -->